// extracted by mini-css-extract-plugin
module.exports = {"historyList":"historyList--k8A4g"};